<template>
  <div class="form-group">
    <label>Body</label>

    <HtmlEditor
      :value="draft.steps.body.html"
      @input="onUpdate"
      :token="`Bearer ${$login.getToken()}`"
      :image-upload-url="imageUploadUrl"
      :file-upload-url="fileUploadUrl"
    />
  </div>
</template>

<script>
import {HtmlEditor} from '@frontend/components'

export default {
  components: {
    HtmlEditor,
  },

  props: {
    draft: {
      type: Object,
      required: true,
    },
  },

  data () {
    return {
      imageUploadUrl: process.env.VUE_APP_API_ENDPOINT + 'upload/image',
      fileUploadUrl: process.env.VUE_APP_API_ENDPOINT + 'upload/file'
    }
  },

  beforeMount () {
    if (!this.draft.steps.body.html) {
      this.draft.steps.body.html = ''
    }
  },

  methods: {
    onUpdate (html) {
      this.$emit('update', {steps:{body: {html}}})
    },
  },
}
</script>
